import { FormControl } from '@angular/forms';
import { ClientService } from '../../../../../services/client.service';

/**
 * Rellena la segunda columna en modo “Cliente”: nombre desde API (empresa) o fallback ya calculado.
 */
export function refreshPortalClientNameInSecondColumn(
    clientService: ClientService,
    exporterCtrl: FormControl<string>,
    fallback: string,
    clientIdNum: number | null,
): void {
    exporterCtrl.setValue(fallback || exporterCtrl.value || '', {
        emitEvent: false,
    });
    if (clientIdNum == null || !Number.isFinite(clientIdNum)) {
        return;
    }
    clientService.getClientById(clientIdNum).subscribe({
        next: (c) => {
            const n = c?.cliente?.trim();
            if (n) {
                exporterCtrl.setValue(n, { emitEvent: false });
            }
        },
        error: () => {},
    });
}
